import React, { Component } from 'react'
import moment from 'moment'
import $ from 'jquery'
import {AppSettings, MessageText, Storage } from '../../configs'

import {
    SecureGateRoute,
    BreadCrumb,
} from "../../components"
import {
    getDocControlAction
    
} from '../../redux/actions/DocControlAction'
import { connect } from 'react-redux'
import MaterialTable from 'material-table'
import {setNotActivePOManualAction} from '../../redux/actions/DocControlAction'
import '../../assets/css/rrs.css'
import {msg} from '../../components/Notifications/MsgBox';
import UserServices from '../../services/UserServices';

class DocControlScreen extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            columns: [
                {
                    field: 'userPic',
                    title: 'User Picture',
                    filtering: false ,
                    render: rowData => 
                    <div>
                        {(!rowData.userPic.includes('C') && !rowData.userPic.includes('admin') ) && 
                        <img src={rowData.userPic} style={{width: 35, borderRadius: '50%'}}/> }
                    </div>
                },
                { title: 'User Name', field: 'userName' },
                { title: 'PO No', field: 'poContractNo' },
                { title: 'Doc No', field: 'docNo' },
                { title: 'Trans No', field: 'transNo' },
                // { title: 'Session No', field: 'sessionNo' },
                { title: 'LastTime', field: 'lastTime',
                  render: rowData => <div>
                    { 
                    [
                    new Date(rowData.lastTime).getDate(),
                    new Date(rowData.lastTime).getMonth()+1,
                    new Date(rowData.lastTime).getFullYear()].join('/')+' '+
                    [new Date(rowData.lastTime).getHours(),
                    new Date(rowData.lastTime).getMinutes(),
                    new Date(rowData.lastTime).getSeconds()].join(':')}
                  </div>
                 },
                { 
                    title: 'Status', field: 'status',
                    lookup: { 'Lock': 'Lock', 'TimeOut': 'TimeOut', 'NotActive': 'NotActive' }, 
                    render: rowData => 
                    <div>
                    { rowData.status == 'Lock' &&
                        (<div style={{color:"#ff0000"}}>
                        {rowData.status}
                        </div>)
                    }
                    { rowData.status == 'TimeOut' &&
                        (<div style={{color:"#ffc107"}}>
                        {rowData.status}
                        </div>)
                    }
                    { rowData.status == 'NotActive' &&
                        (<div style={{color:"#999"}}>
                        {rowData.status}
                        </div>)
                    }
                    </div>
                },
              ],
              data: this.props.docData,
              appReadonly: true
        }

        this.loadData = this.loadData.bind(this)
    }

    componentDidMount() {

        this.loadData()
        this.handleApplicationCheckReadonly()

        $(function () {
            window.onComponentDidMount()
        })
    }

    componentWillReceiveProps(nextProps) {
        
        if (Storage.getUser() && Storage.getUser().isAdmin == true) {
            if (nextProps.docData !== this.state.docData) {

                this.setState({
                    data: nextProps.docData
                })

            }
        }
        else {
            this.props.history.push(AppSettings.defaultUrl)
        }

    }

    async handleApplicationCheckReadonly()
    {
        UserServices.ApplicationReadonly().then(response=>{
            if(response.data === false)
            {
                this.setState({appReadonly: false})
            }
        })
    }

    loadData() {

        if (Storage.getUser() && Storage.getUser().isAdmin == true) {
            this.props.getDocControl()
        }
        else {
            this.props.history.push(AppSettings.defaultUrl)
        }
    }

    render() {

        let { appReadonly } = this.state

        return (
            <div className="rrs">
                <SecureGateRoute />
                <div id="main-content">
                    <div className="page-body">
                        <BreadCrumb breadcrumb={[
                            {name:'RRS Home',url:AppSettings.defaultUrl},
                            {name:'Document Control',url:''}
                        ]}></BreadCrumb>
                        <div className="sp-page-header-panel row">
                            <div className="col-md-5 sp-page-header">
                                <h1 className="sp-page-header1">Document Control</h1>
                            </div>
                        </div>
                        <div className="sp-page-result-container" style={{marginTop:18}} id="user" >
                        <MaterialTable
                                    style={{with:800}}
                                    title=""
                                    columns={this.state.columns}
                                    data={this.state.data}
                                    options={{
                                        filtering: true,
                                        pageSize:20,
                                        headerStyle: {
                                            backgroundColor: '#1f6cd8',
                                            color: '#FFF'
                                        },
                                        actionsColumnIndex: -1
                                    }}
                                    actions={appReadonly? [] : [
                                        {
                                          icon: 'lock_open',
                                          tooltip: 'unlock',
                                          onClick: (event, rowData) => {

                                            if(rowData.status === "Lock"){
                                                let {userId,poContractNo,sessionNo} = rowData
                                                this.props.setNotActivePOManual(userId,poContractNo,sessionNo,false).then(res =>{
                                                    this.loadData()
                                                })
                                            }
                                            else{
                                                msg.error("เอกสารสถานะปลดล็อกอยู่แล้ว")
                                            }


                                          }
                                        },
                                      ]}
                                    editable={{}}
                                    />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { DocControlRedux} = state
    return {
        docData: DocControlRedux.docData,
    }
}

const mapDispatchToProps = dispatch => {
    return {

        getDocControl: () => dispatch(getDocControlAction()),
        setNotActivePOManual: (userId,poNo,sessionNo,isDelete) => dispatch(setNotActivePOManualAction(userId,poNo,sessionNo,isDelete)),
        
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DocControlScreen);